module.exports = __webpack_public_path__ + "img/portugal-cardiovascular-diseases-male.32cb0bcb.png";